module.exports = __webpack_public_path__ + "static/img/6.d1bf33f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/zh/6.png
// module id = /uB7
// module chunks = 0